import src from "IMAGE";
export default { src, width: 1440, height: 400, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARUlEQVR42gWAMQqAIBRAXYSWKE0EhdI0fi1RQt3/aE+UthVtMnMUNvlJ54dbL0w8cPuL0rYwLAmfbkJphNqYgjD6jM0PHaVoFVGjIvZKAAAAAElFTkSuQmCC"};
